import { render, staticRenderFns } from "./RewardTemplateDetail.vue?vue&type=template&id=a6a61678&scoped=true"
import script from "./RewardTemplateDetail.vue?vue&type=script&lang=js"
export * from "./RewardTemplateDetail.vue?vue&type=script&lang=js"
import style0 from "./RewardTemplateDetail.vue?vue&type=style&index=0&id=a6a61678&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a61678",
  null
  
)

export default component.exports